/**
 * Single place to flip search indexing for the Fanbase Fix tool.
 * Keep true while the tool is in development and editorial review.
 */
export const FANBASE_FIX_NOINDEX = true;

export const FANBASE_FIX_PATH = '/fanbase-fix';
export const FANBASE_FIX_CANONICAL = 'https://dk-artists.com/fanbase-fix';

/** Internal review area. Not linked from anywhere on the public site. */
export const REVIEW_ENABLED = true;

export const PRIVACY_URL = '/privacy-policy';
